import { memo, useEffect } from "react";

export const FilePreviewImage: React.FC<{ file: File; isImage?: boolean }> =
  memo(({ file, isImage }) => {
    const url = URL.createObjectURL(file);
    const className = "h-full w-full object-cover pointer-events-none";

    useEffect(() => () => URL.revokeObjectURL(url), [url]);

    return isImage ? (
      <img src={url} alt={file?.name} className={className} />
    ) : (
      <video src={url} className={className} preload="metadata" />
    );
  });
